import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { fg } from '@atlaskit/platform-feature-flags';
import CachingClient from './CachingClient';
import { getOrgIdForCloudIdFromAGG } from './getOrgIdForCloudIdFromAGG';
import { directoryGraphqlQuery } from './graphqlUtils';
export var buildReportingLinesQuery = function buildReportingLinesQuery(aaid) {
  return {
    query: "\n    fragment ReportingLinesUserPII on UserPII {\n      name\n      picture\n    }\n\n    fragment ReportingLinesUserFragment on ReportingLinesUser {\n      accountIdentifier\n      identifierType\n      pii {\n        ...ReportingLinesUserPII\n      }\n    }\n\n    query ReportingLines($aaid: String) {\n      reportingLines(aaidOrHash: $aaid) {\n        managers {\n          ...ReportingLinesUserFragment\n        }\n        reports {\n          ...ReportingLinesUserFragment\n        }\n      }\n    }\n  ",
    variables: {
      aaid: aaid
    }
  };
};
var isTCReadyPromiseMap = new Map();
var globalExperiencePromiseCache = new Map();
var orgIdPromiseCache = new Map();
var TeamCentralCardClient = /*#__PURE__*/function (_CachingClient) {
  _inherits(TeamCentralCardClient, _CachingClient);
  var _super = _createSuper(TeamCentralCardClient);
  /**
   * Simple circuit breaker to avoid making unnecessary calls to Team Central on auth failures
   * This is to handle the case where products may have provided teamCentralUrl, but the site itself
   * doesn't actually have any TC product.
   *
   * There's currently no way to reset this circuit breaker, but that's fine. This is meant to
   * catch a pretty specific edge case.
   */

  function TeamCentralCardClient(options) {
    var _this;
    _classCallCheck(this, TeamCentralCardClient);
    _this = _super.call(this, options);
    _this.options = options;
    _this.bypassOnFailure = false;
    _this.isTCReadyPromise = _this.createTcReadyPromise(options);
    _this.isGlobalExperienceWorkspacePromise = _this.preloadIsGlobalExperienceWorkspace(options.cloudId);
    _this.orgIdPromise = _this.preloadOrgId(options.gatewayGraphqlUrl, options.cloudId, options.orgId);
    return _this;
  }
  _createClass(TeamCentralCardClient, [{
    key: "createTcReadyPromise",
    value: function createTcReadyPromise(config) {
      if (config.cloudId) {
        var promise = isTCReadyPromiseMap.get(config.cloudId);
        if (!promise) {
          promise = this.hasTCWorkspace(config);
          isTCReadyPromiseMap.set(config.cloudId, promise);
        }
        return promise;
      }
      return Promise.resolve(true);
    }
  }, {
    key: "getReportingLines",
    value: function getReportingLines(userId) {
      var _this2 = this;
      return this.isTCReadyPromise.then(function (workSpaceExists) {
        if (workSpaceExists) {
          if (!userId) {
            return Promise.reject(new Error('userId missing'));
          }
          var cache = _this2.getCachedProfile(userId);
          if (cache) {
            return Promise.resolve(cache);
          }
          if (_this2.bypassOnFailure) {
            return Promise.resolve({});
          }
          return new Promise(function (resolve) {
            _this2.makeRequest(userId).then(function (data) {
              var enhancedData = {
                managers: _this2.filterReportingLinesUser(data === null || data === void 0 ? void 0 : data.managers),
                reports: _this2.filterReportingLinesUser(data === null || data === void 0 ? void 0 : data.reports)
              };
              if (_this2.cache) {
                _this2.setCachedProfile(userId, enhancedData);
              }
              resolve(enhancedData);
            }).catch(function (error) {
              if ((error === null || error === void 0 ? void 0 : error.status) === 401 || (error === null || error === void 0 ? void 0 : error.status) === 403) {
                // Trigger circuit breaker
                _this2.bypassOnFailure = true;
              }

              /**
               * Reporting lines aren't part of the critical path of profile card.
               * Just resolve with empty values instead of bubbling up the error.
               */
              resolve({});
            });
          });
        }
        return Promise.resolve({
          managers: [],
          reports: []
        });
      }, function () {
        return Promise.resolve({
          managers: [],
          reports: []
        });
      });
    }

    /**
     * `public` so that mock client can override it; do not use it otherwise!
     */
  }, {
    key: "makeRequest",
    value: (function () {
      var _makeRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(userId) {
        var query, response, _query, _response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!fg('enable_ptc_sharded_townsquare_calls')) {
                _context.next = 10;
                break;
              }
              if (!(this.options.teamCentralDisabled === true)) {
                _context.next = 3;
                break;
              }
              throw new Error('makeRequest cannot be called when the client has been disabled');
            case 3:
              query = buildReportingLinesQuery(userId);
              _context.next = 6;
              return directoryGraphqlQuery('/gateway/api/watermelon/graphql?operationName=ReportingLines', query);
            case 6:
              response = _context.sent;
              return _context.abrupt("return", response.reportingLines);
            case 10:
              if (this.options.teamCentralUrl) {
                _context.next = 12;
                break;
              }
              throw new Error('options.teamCentralUrl is a required parameter for retrieving Team Central data');
            case 12:
              _query = buildReportingLinesQuery(userId);
              _context.next = 15;
              return directoryGraphqlQuery("".concat(this.options.teamCentralUrl, "?operationName=ReportingLines"), _query);
            case 15:
              _response = _context.sent;
              return _context.abrupt("return", _response.reportingLines);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function makeRequest(_x) {
        return _makeRequest.apply(this, arguments);
      }
      return makeRequest;
    }())
  }, {
    key: "checkWorkspaceExists",
    value: function checkWorkspaceExists() {
      return this.isTCReadyPromise.then(function (workSpaceExists) {
        if (workSpaceExists) {
          return Promise.resolve(true);
        }
        return Promise.resolve(false);
      }, function () {
        return Promise.resolve(false);
      });
    }
  }, {
    key: "getIsGlobalExperienceWorkspace",
    value: function getIsGlobalExperienceWorkspace() {
      return this.isGlobalExperienceWorkspacePromise;
    }
  }, {
    key: "getOrgId",
    value: function getOrgId() {
      return this.orgIdPromise;
    }
  }, {
    key: "preloadIsGlobalExperienceWorkspace",
    value: function preloadIsGlobalExperienceWorkspace(cloudId) {
      if (!fg('enable_ptc_sharded_townsquare_calls')) {
        return Promise.resolve(false);
      }
      if (cloudId === undefined) {
        return Promise.resolve(false);
      }
      var maybeIsGlobalExperienceWorkspaceForCloudIdPromise = globalExperiencePromiseCache.get(cloudId);
      if (maybeIsGlobalExperienceWorkspaceForCloudIdPromise !== undefined) {
        return maybeIsGlobalExperienceWorkspaceForCloudIdPromise;
      }
      var isGlobalExperienceWorkspaceForCloudIdPromise = this.isGlobalExperienceWorkspaceForCloudId(cloudId);
      globalExperiencePromiseCache.set(cloudId, isGlobalExperienceWorkspaceForCloudIdPromise);
      return isGlobalExperienceWorkspaceForCloudIdPromise;
    }
  }, {
    key: "hasTCWorkspace",
    value: function hasTCWorkspace(config) {
      if (config.cloudId) {
        var maybeShardedApiPath = this.getMaybeShardedApiPath(config.cloudId);
        return fetch("".concat(maybeShardedApiPath, "/organization/containsAnyWorkspace?cloudId=").concat(config.cloudId)).then(function (res) {
          return !res || res && res.ok;
        });
      } else {
        return Promise.resolve(false);
      }
    }
  }, {
    key: "isGlobalExperienceWorkspaceForCloudId",
    value: function () {
      var _isGlobalExperienceWorkspaceForCloudId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(cloudId) {
        var maybeShardedApiPath, response, workspaceType;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              maybeShardedApiPath = this.getMaybeShardedApiPath(cloudId);
              _context2.prev = 1;
              _context2.next = 4;
              return fetch("".concat(maybeShardedApiPath, "/workspace/existsWithWorkspaceType?cloudId=").concat(cloudId), {
                credentials: 'include'
              });
            case 4:
              response = _context2.sent;
              if (!response.ok) {
                _context2.next = 10;
                break;
              }
              _context2.next = 8;
              return response.text();
            case 8:
              workspaceType = _context2.sent;
              return _context2.abrupt("return", Promise.resolve(workspaceType === 'GLOBAL_EXPERIENCE'));
            case 10:
              return _context2.abrupt("return", Promise.resolve(false));
            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](1);
              return _context2.abrupt("return", Promise.resolve(false));
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 13]]);
      }));
      function isGlobalExperienceWorkspaceForCloudId(_x2) {
        return _isGlobalExperienceWorkspaceForCloudId.apply(this, arguments);
      }
      return isGlobalExperienceWorkspaceForCloudId;
    }()
  }, {
    key: "preloadOrgId",
    value: function preloadOrgId(gatewayGraphqlUrl, cloudId, orgId) {
      if (!fg('enable_ptc_sharded_townsquare_calls')) {
        return Promise.resolve(null);
      }
      if (cloudId === undefined) {
        return Promise.resolve(null);
      }
      if (orgId !== undefined) {
        return Promise.resolve(orgId);
      }
      var maybeOrgIdForCloudIdPromise = orgIdPromiseCache.get(cloudId);
      if (maybeOrgIdForCloudIdPromise !== undefined) {
        return maybeOrgIdForCloudIdPromise;
      }
      var orgIdForCloudIdPromise = getOrgIdForCloudIdFromAGG(gatewayGraphqlUrl, cloudId);
      orgIdPromiseCache.set(cloudId, orgIdForCloudIdPromise);
      return orgIdForCloudIdPromise;
    }
  }, {
    key: "getMaybeShardedApiPath",
    value: function getMaybeShardedApiPath(cloudId) {
      var maybeShardedPath = fg('enable_ptc_sharded_townsquare_calls') ? "/townsquare/s/".concat(cloudId) : '/watermelon';
      return "/gateway/api".concat(maybeShardedPath);
    }
  }, {
    key: "filterReportingLinesUser",
    value: function filterReportingLinesUser() {
      var users = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return users.filter(function (user) {
        return user.identifierType === 'ATLASSIAN_ID';
      });
    }
  }]);
  return TeamCentralCardClient;
}(CachingClient);
export default TeamCentralCardClient;